import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function SparkleIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
      >
        <path
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.421}
          d="M12.031 8.321a4.12 4.12 0 0 1-4.136-4.135A4.12 4.12 0 0 1 3.76 8.321a4.12 4.12 0 0 1 4.135 4.135 4.12 4.12 0 0 1 4.135-4.135M14.946 13.486A1.937 1.937 0 0 1 13 11.54a1.937 1.937 0 0 1-1.946 1.946A1.937 1.937 0 0 1 13 15.432a1.937 1.937 0 0 1 1.946-1.946"
        />
      </svg>
    </Icon>
  )
}
export default SparkleIcon
